"use strict";
exports.__esModule = true;
exports.t_global_breakpoint_md = {
  "name": "--pf-t--global--breakpoint--md",
  "value": "48rem",
  "var": "var(--pf-t--global--breakpoint--md)"
};
exports["default"] = exports.t_global_breakpoint_md;